import React, { useRef } from 'react';
import cx from 'clsx';

import styles from './Layout.module.scss';
import config from '../../config';
import DeviceProvider from '../DeviceProvider';
import { CallbackMode, DeviceOs } from '../../logic/main/types';
import { GameLaunchStrategies } from '../../types/gameTypes';
import { LaunchStrategiesProvider } from '../LaunchStrategiesProvider';

interface LayoutPropTypes {
  children?: React.ReactNode;
  isNavigationVisible?: boolean;
  isFooterVisible?: boolean;
  deviceType: 'mobile' | 'tablet' | 'desktop';
  deviceOs: DeviceOs;
  launchStrategies: GameLaunchStrategies;
  deviceNative: boolean;
  gameModalOpen?: boolean;
  callbackMode: CallbackMode;
}

const Layout: React.FC<LayoutPropTypes> = ({
  children,
  deviceType,
  deviceOs,
  launchStrategies,
  deviceNative,
  gameModalOpen,
  callbackMode,
}) => {
  const mode = config.staticComponents['Layout']?.mode || 'default';

  const layoutRootRef = useRef(null);

  return (
    <LaunchStrategiesProvider
      launchStrategies={launchStrategies}
      callbackMode={callbackMode}
    >
      <DeviceProvider
        deviceType={deviceType}
        deviceOs={deviceOs}
        deviceNative={deviceNative}
      >
        <div
          className={cx(styles.layout, {
            [styles.layoutWithNavigation]: mode === 'small',
            [styles.layoutWithFooter]: mode === 'small',
            [styles.overflowHidden]: gameModalOpen,
          })}
          ref={layoutRootRef}
          id="layout"
          data-testid="layout"
        >
          <div
            className={cx(styles.content, {
              [styles.contentResponsive]: mode === 'default',
              [styles.contentStatic]: mode !== 'default',
            })}
            data-testid="page-content"
            id="page-content"
          >
            {children}
          </div>
        </div>
      </DeviceProvider>
    </LaunchStrategiesProvider>
  );
};

export default Layout;
